import { Card } from '@/components/ui/card';
import { Warehouse, Truck, MapPin } from 'lucide-react';

interface MappingStatsProps {
  stats: {
    totalLocations: number;
    activeRoutes: number;
    coverageAreas: number;
  };
}

export function MappingStats({ stats }: MappingStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <Warehouse className="w-5 h-5 text-blue-600" />
          <span className="text-sm text-muted-foreground">Total Locations</span>
        </div>
        <div className="text-2xl font-semibold">{stats.totalLocations}</div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <Truck className="w-5 h-5 text-green-600" />
          <span className="text-sm text-muted-foreground">Active Routes</span>
        </div>
        <div className="text-2xl font-semibold">{stats.activeRoutes}</div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <MapPin className="w-5 h-5 text-orange-600" />
          <span className="text-sm text-muted-foreground">Coverage Areas</span>
        </div>
        <div className="text-2xl font-semibold">{stats.coverageAreas}</div>
      </Card>
    </div>
  );
}
